import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { House, FilePlus, SignOut, Buildings, ListChecks, PhoneCall, Wallet } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();
  const [actionCount, setActionCount] = useState(0);

  useEffect(() => {
    api.get("/dossiers/action-count").then((r) => setActionCount(r.data.count)).catch(() => {});
  }, [location.pathname]);

  const items = [
    { label: "Dossiers", icon: House, path: "/admin" },
    { label: "À traiter", icon: ListChecks, path: "/admin/a-traiter" },
    { label: "Visites à planifier", icon: PhoneCall, path: "/admin/visites" },
    { label: "Budget", icon: Wallet, path: "/admin/budget" },
    { label: "Nouveau dossier", icon: FilePlus, path: "/admin/nouveau" },
  ];

  return (
    <aside className="w-64 bg-slate-900 text-white min-h-screen fixed left-0 top-0 flex flex-col" data-testid="sidebar">
      <div className="px-6 py-8 border-b border-slate-800">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-md bg-blue-600 flex items-center justify-center">
            <Buildings size={20} weight="bold" className="text-white" />
          </div>
          <div>
            <p className="font-heading font-semibold text-[15px] leading-tight">Certicapitale — Isoconseil</p>
            <p className="text-[11px] text-slate-400">Portail Expert</p>
          </div>
        </div>
        <p className="text-[10px] text-slate-400 leading-relaxed mt-3">
          Certificat PEB · Réception PEB chauffage · Certibeau · Audit énergétique PAE · Réception PAC RESCERT
        </p>
      </div>

      <nav className="flex-1 px-3 py-6 space-y-1">
        {items.map((it) => {
          const active = location.pathname === it.path;
          const Icon = it.icon;
          return (
            <button
              key={it.path}
              data-testid={`nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => navigate(it.path)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                active ? "bg-blue-600 text-white" : "text-slate-300 hover:bg-slate-800"
              }`}
            >
              <Icon size={18} weight={active ? "fill" : "regular"} />
              <span className="flex-1 text-left">{it.label}</span>
              {it.path === "/admin" && actionCount > 0 && (
                <span data-testid="sidebar-action-badge"
                  className={`min-w-5 h-5 px-1.5 flex items-center justify-center rounded-full text-[11px] font-semibold ${active ? "bg-white/25 text-white" : "bg-orange-500 text-white"}`}>
                  {actionCount}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="px-3 py-6 border-t border-slate-800">
        <p className="px-3 text-xs text-slate-400 mb-2 truncate">{user?.email}</p>
        <button
          data-testid="logout-button"
          onClick={() => { logout(); navigate("/login"); }}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-slate-300 hover:bg-slate-800 transition-colors"
        >
          <SignOut size={18} />
          Déconnexion
        </button>
      </div>
    </aside>
  );
};
